import React from 'react';
import Person from '@material-ui/icons/Person';
import classnames from 'classnames';

const PersonIcon = ({ className, ...props }) => (
  <Person
    style={{
      margin: '0px 3px',
      fontSize: '13px',
      fill: 'rgb(140 142 152)'
    }}
    className={classnames({
      icon: true,
      [className]: !!className
    })}
    {...props}
  />
);

export default PersonIcon;
